import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=06271000&scoped=true"
import script from "./Dish.vue?vue&type=script&lang=js"
export * from "./Dish.vue?vue&type=script&lang=js"
import style0 from "./Dish.vue?vue&type=style&index=0&id=06271000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06271000",
  null
  
)

export default component.exports